import s1 from '../Assets/Videos/song1.mp3'
import s2 from '../Assets/Videos/song2.mp3'
import s3 from '../Assets/Videos/song3.mp3'
import s4 from '../Assets/Videos/song4.mp3'

import m1 from '../Assets/images/aadujeevitham-vellikkinavu (1).jpg'
import m2 from '../Assets/images/aadujeevitham.jpg'
import m3 from '../Assets/images/kachisera.jpg'
import m4 from '../Assets/images/railin-pic.jpg'
const SongData = [
  {
    id: "t1",
    src: s1, 
    title: "Omane - Malayalam",
    description:"Aadujeevitham | @ARRahman | Chinmayi, Vijay Yesudas ",
    imageUrl: m1,
  },
  {
    id: "t2",
    src: s2, 
    title: "Periyone Song - Malayalam",
    description:"The GoatLife | Aadujeevitham | A.R. Rahman |Jithin Raj | Rafeeq Ahammed",
    imageUrl: m2,
  },
  {
    id: "t3",
    src: s3, 
    title: "Railin Oliga - Tamil",
    description:"Ashok Selvan, Keerthi | Govind Vasantha | S.Jaya Kumar | Pa.Ranjith ",
    imageUrl: m4,
  },
  {
    id: "t4",
    src: s4, 
    title: "Katchi Sera Song- Tamil",
    description:"Sai Abhyankkar| Samyuktha | Ken Royson | Think Indie",
    imageUrl:  m3,
  },
];

export default SongData;
